var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutoralLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281.05,
    height: 185.01,
    fill: "currentColor",
    viewBox: "0 0 281.05 185.01",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419.31 -301.99)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m560.64 301.99-139.7 85.739 1.062 0.816v37.49c0 5.298 3.174 5.216 3.174 5.216 4.238 0 3.826-4.238 3.826-4.238v-33.904l38 23.473v25.863l71 44.554v-11.735c17 0.651 16-10.433 16-10.433v-87.829h-21.434c-12.823 0-14.563 18-14.563 18h-3.477l3.477-19h86.72l3.259 19h-2.933c-2.065-18-14.672-18-14.672-18h-21.378v87.503c0 14.018 15 10.759 15 10.759v11.409l71-44.011v-26.896l45.359-27.711zm-28.637 175.23-60-37.981v-19.397l60 37.164zm9.123-8.218h-3.123v-10.039l10.363 5.591c0.573 5.297-7.24 4.448-7.24 4.448zm42.877 0h-2.098s-8.324 0.849-7.753-4.448l9.851-5.591zm66-29.764-61 37.981v-20.214l61-37.164zm-76 19.725v-75.961h16.27c6.52 0 7.824 6.718 7.824 6.718l2.717 11.282h13.691l-5.216-31h-95.954l-5.107 31h13.692l2.065-8.945c2.824-10.596 9.67-9.055 9.67-9.055h15.348v76.83l-117.76-71.938 129.68-79.438 129.55 79.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.16 438.31s-4.781 11.846-1.956 18.147c0 0 1.549 3.641 4.877 4.155 1.755 0.271 4.822-0.677 6.1-4.155 0 0 3.367-8.041-2.826-19.234 0 1e-3 -2.934-5.976-6.195 1.087z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutoralLogo);
export default __webpack_public_path__ + "static/media/TutoralLogo.94729c36253e7388e58613cf319414be.svg";
export { ForwardRef as ReactComponent };